import React, { useContext } from 'react';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { Container } from '@pwskills/rachnaui';
import Faqs from '../../Faqs';

const Faq = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { faq } = courseDetails?.courseMetaDetails || {};

  return (
    <div>
      {faq && faq?.length > 0 && (
        <section id="faqs" data-title="FAQs">
          <Container className="py-8 medium:py-12 large:!py-14">
            <Faqs
              faqsList={faq}
              classes="flex justify-start regular:!w-full"
              showViewAllButton={false}
              wrapperClass="[&>header]:!pb-[12px] [&>header]:medium:!pb-[32px] [&>header]:large:!pb-[58px]"
            />
          </Container>
        </section>
      )}
    </div>
  );
};

export default Faq;
